module.exports = __webpack_public_path__ + "img/san2-.2368c66a.jpeg";